<template>
  <button role="button" class="rhg-instructions-map__button" @click="handleViewChangeClick" :class="{disabled: disableButton}" :disabled="disableButton">
    <span v-if="showViewInstructionsText">
      {{ translate('weViewInstructions') }}
    </span>
    <span v-else>
      {{ translate('weViewMap') }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  data: () => ({
    showViewInstructionsText: false
  }),
  props: {
    showMap: Boolean,
    disableButton: Boolean
  },
  created() {
    this.showViewInstructionsText = this.showMap
  },
  methods: {
    handleViewChangeClick() {
      this.$emit('onViewComponentChange', !this.showMap)
    }
  },
  watch: {
    showMap: function(val) {
      this.showViewInstructionsText = val
    }
  }
}
</script>

<style lang="scss" scoped>
.rhg-instructions-map__button {
  color: color('black-discovery');
  border: 2px solid color('black-discovery');
  border-radius: 24px;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  padding: 8px 24px;
  background: transparent;
  font-weight: 700;

  span {
    width: max-content;
  }

  @media (hover: hover) {
    &:hover:enabled {
      background: color('black-discovery');
      color: #fff;
    }
  }

  &:disabled {
    cursor: default;
  }
}

.disabled {
  opacity: 0.5;
}
</style>
